import { Observable, take } from "rxjs";
import { inject, Injectable } from "@angular/core";
import {
  ref,
  getDatabase,
  DataSnapshot,
  goOnline,
  goOffline,
} from "@angular/fire/database";
import { getApp } from "@angular/fire/app";
import { Database, onValue } from "@angular/fire/database";
import { StorageService } from "../storage-service/storage.service";
import { FirebaseService } from "../firebase-service/firebase.service";
import { DataFetchModel } from "src/app/store/models/realTimeDB.model";

@Injectable({ providedIn: "root" })
export class FirebaseRealtimeService {
  private firebaseService = inject(FirebaseService);
  private storage = inject(StorageService);

  constructor() {}

  getAllData<T = any>(path: string): Observable<T | null> {
    return new Observable<T | null>((subscriber) => {
      let detachListener: (() => void) | null = null;

      Promise.all([this.storage.get("realtimeDB"), this.storage.get("user")])
        .then(([realtimeDB, user]) => {
          const app = getApp();
          const db = getDatabase(app, realtimeDB);
          const dbRef = ref(db, path);

          detachListener = onValue(
            dbRef,
            (snapshot: DataSnapshot) => {
              subscriber.next(snapshot.val());
            },
            (error) => {
              subscriber.error(error);
            },
          );
        })
        .catch((error) => {
          subscriber.error(error);
        });

      // Teardown: called by RxJS when takeUntil fires or subscriber unsubscribes
      return () => {
        if (detachListener) detachListener();
      };
    });
  }

  getLastUpdatedTimestamp(): Observable<DataFetchModel> {
    return new Observable<DataFetchModel>((subscriber) => {
      let detachListener: (() => void) | null = null;

      Promise.all([this.storage.get("realtimeDB")])
        .then(([realtimeDB]) => {
          const path = `data-refresh`;
          const app = getApp();
          const db = getDatabase(app, realtimeDB);
          const dbRef = ref(db, path);

          detachListener = onValue(
            dbRef,
            (snapshot: DataSnapshot) => {
              subscriber.next(snapshot.val());
            },
            (error) => {
              subscriber.error(error);
            },
          );
        })
        .catch((error) => {
          subscriber.error(error);
        });

      // Teardown: called by RxJS when takeUntil fires or subscriber unsubscribes
      return () => {
        if (detachListener) detachListener();
      };
    });
  }
  async forceReconnect(): Promise<void> {
    const realtimeDB = await this.storage.get("realtimeDB");
    if (!realtimeDB) return;

    const db = getDatabase(getApp(), realtimeDB);
    goOffline(db);
    setTimeout(() => goOnline(db), 500);
  }
}
